import { render, staticRenderFns } from "./SwipedEventBannerSmall.vue?vue&type=template&id=9834de70&scoped=true&"
import script from "./SwipedEventBannerSmall.vue?vue&type=script&lang=js&"
export * from "./SwipedEventBannerSmall.vue?vue&type=script&lang=js&"
import style0 from "./SwipedEventBannerSmall.vue?vue&type=style&index=0&id=9834de70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9834de70",
  null
  
)

export default component.exports